{
  "anonymousConsents": {
    "preferences": "Preferencias de consentimiento",
    "dialog": {
      "title": "Gestión de consentimientos",
      "legalDescription": "Usamos cookies/almacenamiento del navegador para personalizar el contenido y mejorar la experiencia del usuario. También podríamos compartir los datos sobre el uso de su sitio con nuestras redes sociales. Para más información, por favor revise nuestra política de privacidad.",
      "selectAll": "Seleccionar todo",
      "clearAll": "Borrar todo"
    },
    "banner": {
      "title": "Este sitio web utiliza cookies",
      "description": "Usamos cookies/almacenamiento del navegador para personalizar el contenido y mejorar la experiencia del usuario.",
      "allowAll": "Permitir todo",
      "viewDetails": "Ver detalles"
    }
  },
  "checkoutLogin": {
    "emailAddress": {
      "label": "Dirección de correo electrónico",
      "placeholder": "Ingresar correo electrónico"
    },
    "confirmEmail": {
      "label": "Confirmar correo electrónico",
      "placeholder": "Confirmar correo electrónico"
    },
    "continue": "Continuar",
    "emailIsRequired": "Formato de correo electrónico inválido",
    "emailsMustMatch": "El correo electrónico no coincide"
  },
  "authMessages": {
    "signedOutSuccessfully": "Sesión cerrada correctamente",
    "unrecoverableError": "No se puede ingresar, intente nuevamente sin usar el modo incógnito o aceptando las cookies de terceros."
  }
}